module.exports = __webpack_public_path__ + "static/media/VITAMINAS.40f663e8.gif";